(function(){
    'use strict';

    angular
        .module('completeAir')
        .directive('emailValidator', function emailValidator() {
            return {
                require: 'ngModel',
                link: function (scope, element, attrs, control) {
                    control.$parsers.push(function (viewValue) {
                        var newEmail = control.$viewValue;
                        //var expressionEmail = /^(([a-zA-Z0-9_.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([;,.](([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/;
                        //var expressionEmail = /^([^\x00-\x20\x21\x22\x23\x24\x25\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x60\x5b-\x5d\x7c\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/
                        var expressionEmail = /^(([^<>()\[\]\\.,;:\s@"|%`$!#]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        control.$setValidity("email", true);
                        if (typeof newEmail === "object" || newEmail == "") return newEmail;
                        if (!newEmail.match(expressionEmail))
                            control.$setValidity("email", false);
                        return viewValue;
                    });
                }
            };
        })
        .directive('emailValidatorCustom', function emailValidator() {
            return {
                restrict : 'A',
                require: 'ngModel',
                scope : {
                    emailValidatorCustom : '=emailValidatorCustom'
                },
                link: function (scope, element, attrs, control) {
                    control.$parsers.push(function (viewValue) {
                        var newEmail = control.$viewValue;
                        var strIndex = newEmail.indexOf("@");
                        var strEmailChar = newEmail.charAt(strIndex-1);
                        var strEmail = newEmail.substring(0, strIndex);

                        control.$setValidity("emailCustom", true);

                        if(strIndex !== -1 && !isNaN(strEmail)){
                            control.$setValidity("emailCustom", false);
                        }

                        if(strIndex !== -1 && (strEmailChar === '_' || strEmailChar === '-' || strEmailChar === '+')){
                            control.$setValidity("emailCustom", false);
                        }

                        return viewValue;
                    });
                }
            };
        })
        .directive('alphabeticValidator', function alphabeticValidator() {
            return {
                require: 'ngModel',
                link: function (scope, element, attrs, control) {
                    control.$parsers.push(function (viewValue) {
                        var newValue = control.$viewValue;
                        control.$setValidity("alphabetic", true);
                        if (typeof newValue === "object" || newValue == "") return newValue;
                        if (!newValue.match(/^[A-Za-z\s\xF1\xD1]+$/))
                            control.$setValidity("alphabetic", false);
                        return viewValue;
                    });
                }
            };
        })
        .directive('phoneValidator', function alphabeticValidator() {
            return {
                require: 'ngModel',
                link: function (scope, element, attrs, control) {
                    control.$parsers.push(function (viewValue) {
                        var newValue = control.$viewValue;
                        control.$setValidity("phone", true);
                        if (typeof newValue === "object" || newValue == "") return newValue;
                        if (!newValue.match(/^[0-9\s\xF1\xD1]+$/))
                            control.$setValidity("phone", false);
                        return viewValue;
                    });
                }
            };
        })
        .directive('numberValidator', function alphabeticValidator() {
            return {
                require: 'ngModel',
                link: function (scope, element, attrs, control) {
                    control.$parsers.push(function (viewValue) {
                        var newValue = control.$viewValue;
                        control.$setValidity("number", true);
                        if (typeof newValue === "object" || newValue == "") return newValue;
                        if (!newValue.match(/^\d{0,9}(\.\d{1,9})?$/))
                            control.$setValidity("number", false);
                        return viewValue;
                    });
                }
            };
        })
        .directive('wordValidator', function alphabeticValidator() {

            function isWordCorrect(words) {
                var res = true;
                for (var i = 0; i < words.length; i++) {
                    if (words[i].length === 1) {
                        res = false;
                        break;
                    }
                }
                return res;
            }

            return {
                require: 'ngModel',
                link: function (scope, element, attrs, control) {
                    control.$parsers.push(function (viewValue) {
                        var newValue = control.$viewValue;

                        control.$setValidity("word", true);
                        if (typeof newValue === "object" || newValue === "") return newValue;

                        var words = newValue.split(' ');

                        if(words.length > 1) {
                            var wordCorrect = isWordCorrect(words);
                            if (wordCorrect) {
                                control.$setValidity("word", true);
                            } else {
                                control.$setValidity("word", false);
                            }
                        }
                        return viewValue;
                    });
                }
            };
        })
        .directive('minValidator', function numberValidator() {

            function isNumberCorrect(number) {
                return !isNaN(parseFloat(number));
            }

            return {
                require: 'ngModel',
                link: function (scope, element, attrs, control) {
                    control.$parsers.push(function (viewValue) {
                        var newValue = control.$viewValue;
                        control.$setValidity("minimum", true);
                        if (typeof newValue === "object" || newValue === "") return newValue;

                        if(newValue.length >= 1) {
                            var numberCorrect = isNumberCorrect(newValue);
                            if (numberCorrect) {
                                if(parseFloat(newValue) < parseInt(attrs.minValidator)){
                                    control.$setValidity("minimum", false);
                                }
                            }
                        }
                        return viewValue;
                    });
                }
            };
        })
        .directive('maxValidator', function numberValidator() {

            function isNumberCorrect(number) {
                return !isNaN(parseFloat(number));
            }

            return {
                require: 'ngModel',
                link: function (scope, element, attrs, control) {
                    control.$parsers.push(function (viewValue) {
                        var newValue = control.$viewValue;
                        control.$setValidity("maximum", true);
                        if (typeof newValue === "object" || newValue === "") return newValue;

                        if(newValue.length >= 1) {
                            var numberCorrect = isNumberCorrect(newValue);
                            if (numberCorrect) {
                                if(parseFloat(newValue) > parseInt(attrs.maxValidator)){
                                    control.$setValidity("maximum", false);
                                }
                            }
                        }
                        return viewValue;
                    });
                }
            };
        })
        .directive('httpsUrlValidator', function httpsUrlValidator() {
            return {
                require: 'ngModel',
                link: function (scope, element, attrs, control) {
                    control.$parsers.push(function (viewValue) {
                        var newUrl = control.$viewValue;
                        var expressionUrl = /^https:\/\/[^\s/$.?#].[^\s]*$/i;
                        control.$setValidity("url", true);

                        if (!newUrl || newUrl === "") return newUrl;

                        if (!expressionUrl.test(newUrl)) {
                            control.$setValidity("url", false);
                        }

                        return viewValue;
                    });
                }
            };
        })
        .directive('minimumPrice', function minimumPrice() {
            return {
                require: 'ngModel',
                link: function (scope, element, attrs, control) {
                    control.$parsers.push(function (viewValue) {
                        var price = control.$viewValue;

                        control.$setValidity("minimumPrice", true);

                        var number = parseFloat(price);

                        if (number <= 0) {
                            control.$setValidity("minimumPrice", false);
                        }

                        return viewValue;
                    });
                }
            };
        });
})();
